import React from "react";
import Grid, { GridProps } from "@mui/material/Grid";

interface AlignCenterProps extends GridProps {
  children: React.ReactNode;
  withMaxWidth?: boolean;
  centerBothAxis?: boolean;
  row?: boolean;
}

const AlignCenter: React.FC<AlignCenterProps> = ({
  children,
  withMaxWidth = false,
  centerBothAxis = false,
  row = true,
  style,
  ...rest
}) => {
  return (
    <Grid
      className="alignCenter"
      container
      direction={row === true ? "row" : "column"}
      alignItems="center"
      justifyContent="center"
      style={{
        width: withMaxWidth ? "100%" : "auto",
        height: centerBothAxis ? "100%" : "auto",
        ...style,
      }}
      {...rest}
    >
      <Grid
        item
        xs={withMaxWidth ? 11 : 12}
        sm={withMaxWidth ? 10 : 12}
        md={withMaxWidth ? 9 : 12}
        lg={withMaxWidth ? 8 : 12}
        xl={withMaxWidth ? 9 : 12}
      >
        <Grid
          container
          direction={row === true ? "row" : "column"}
          justifyContent="center"
          alignItems="center"
          style={{ width: "100%", height: "100%" }}
        >
          {withMaxWidth === true ? (
            <Grid item style={{ maxWidth: 600, width: "100%" }}>
              <div style={{ width: "100%" }}>{children}</div>
            </Grid>
          ) : (
            <div style={{ width: "100%" }}>{children}</div>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default AlignCenter;
